var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBpmIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 476.211,
    height: 258.858,
    viewBox: "0 0 476.211 258.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d,.h,.p,.q,.u,.v,.w{fill:none;}.b{fill:#8797a8;}.c,.d{stroke:#0054a8;}.c{stroke-width:5px;}.c,.d,.w{stroke-dasharray:3;}.d{stroke-linejoin:round;stroke-width:3px;}.e{fill:#c6cfdb;}.f{fill:#ffc503;}.g{fill:#00be2c;}.h{stroke:#acb6c1;}.i{fill:#052f35 ;}.j{fill:url(#a);}.k,.o{fill:#fff;}.l{fill:#0054a8;}.m{fill:url(#b);}.n{fill:#e4ebf4;}.o,.u{stroke:#8797a8;}.p,.q{stroke:#fff;}.q,.v{stroke-linecap:round;}.r{fill:#d30000;}.s{clip-path:url(#d);}.t{fill:#acb6c1;}.u{stroke-width:2px;}.v{stroke:#00be2c;}.w{stroke:#10002e;}.x{stroke:none;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.423,
    y1: 0.5,
    x2: 0.836,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0054a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#052f35 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.577,
    x2: 0.164,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 33
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1003.841 -425.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1003.841 442.954)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.673,79.372A36.371,36.371,0,0,0,56.82,78.32l1.913,1.4,3.039,2.219a1.756,1.756,0,0,0,.886-1.184C62.683,80.308,62.352,79.835,61.673,79.372Z",
    transform: "translate(-23.775 -14.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.242,80.443l-3.023-2.2-3.23,2.1a38.69,38.69,0,0,1,7.9,1.317Z",
    transform: "translate(-22.945 -14.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.36,77.717l4.853,2.451,3.313-2.145A46.666,46.666,0,0,0,45.36,77.717Z",
    transform: "translate(-21.805 -14.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.72,78.71l-1.731-.87L41.48,80.589a44.2,44.2,0,0,1,6-.406c.4,0,.787,0,1.184.017Z",
    transform: "translate(-21.138 -14.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M42.359,77.83a38.739,38.739,0,0,0-7.279,1.284l4.72,1.524Z",
    transform: "translate(-20.038 -14.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.7,81.112l-4.58-1.482a1.839,1.839,0,0,0-.853,1.226,1.71,1.71,0,0,0,.853,1.325A34.549,34.549,0,0,1,38.7,81.112Z",
    transform: "translate(-19.727 -14.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.873,85.02a1.791,1.791,0,0,0-.754,1.192,1.7,1.7,0,0,0,.8,1.325c.282-.091,1.085-.356,2.319-.646Z",
    transform: "translate(-19.873 -15.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.54,84.64l2.31,1.822,1.234-2.691A31.187,31.187,0,0,0,35.54,84.64Z",
    transform: "translate(-20.118 -15.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.082,83.77l-1,2.2-.24.522a40.172,40.172,0,0,1,5.151-.745Z",
    transform: "translate(-20.685 -15.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.056,85.527l2.708-2.509a37.806,37.806,0,0,0-6.774.455Z",
    transform: "translate(-21.054 -15.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.691,85.672,49.207,83.13l-.166.157L46.59,85.565A37.308,37.308,0,0,1,51.691,85.672Z",
    transform: "translate(-22.017 -15.456)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.983,83.88a41.561,41.561,0,0,0-6.633-.82l2.559,2.609Z",
    transform: "translate(-22.663 -15.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.232,84.27l-.994.431L54.29,86a34.99,34.99,0,0,1,5.921,1.267Z",
    transform: "translate(-23.34 -15.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.515,84.835c-.141-.05-.8-.257-1.855-.505l2,3.039a1.687,1.687,0,0,0,.778-1.143C62.467,85.771,62.153,85.3,61.515,84.835Z",
    transform: "translate(-24.263 -15.662)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M60.3,90.32,57.62,92.034c.9.232,1.8.5,2.667.8a1.764,1.764,0,0,0,.787-1.184A1.7,1.7,0,0,0,60.3,90.32Z",
    transform: "translate(-23.912 -16.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M59.325,89.865A32.315,32.315,0,0,0,54.48,88.78l2.145,2.807Z",
    transform: "translate(-23.373 -16.427)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.242,88.79,50.17,90.91a30.8,30.8,0,0,1,5.184.638Z",
    transform: "translate(-22.632 -16.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.937,90.832,45.7,88.48,44.343,90.1l-.853,1.01a33.042,33.042,0,0,1,4.323-.282Z",
    transform: "translate(-21.484 -16.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.147,88.566a33.6,33.6,0,0,0-5.457-.232l2.294,2.41Z",
    transform: "translate(-22.034 -16.345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.188,19.44,73.9,21.56,67.46,27.547l7.486,2.9,2.981,1.159C78.11,30.33,78.83,24.185,76.188,19.44Z",
    transform: "translate(-25.604 -4.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.45,38.295l6.758,8.074c.72-1.168,3.892-6.584,4.472-11.569l-7.445,2.31Z",
    transform: "translate(-25.43 -7.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.064,29.65l-.754,7.379,10.973-3.412Z",
    transform: "translate(-25.406 -6.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.84,16.884A28.7,28.7,0,0,0,67.691,7.75l-.571,8.414Z",
    transform: "translate(-25.545 -2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.713,19.1,67.1,18.39l.116,8.6,2.161-2Z",
    transform: "translate(-25.542 -4.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.16,47.992l1-.066,9.755-.613L65.243,39.33Z",
    transform: "translate(-24.521 -7.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.077,53.326,67.3,57c.687-1.159,3.594-6.07,4.629-7.553l-10.658.671Z",
    transform: "translate(-24.54 -9.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.19,57.93l11.627,6.534a38.544,38.544,0,0,1,2.468-5.49l-8.083-.6Z",
    transform: "translate(-22.807 -11.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M65.064,57.27l-6.029-6.89L50.82,56.21l10.12.754Z",
    transform: "translate(-22.744 -9.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.01,12.905,65,15.944l.563-8.314-8.5,2.261Z",
    transform: "translate(-23.816 -2.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.084,8.559l3.023-.8,5.557-1.482A29.672,29.672,0,0,0,53.26,1.76l.24.563Z",
    transform: "translate(-23.163 -1.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.769,21.96l-.05-3.52L55.56,21.015l9.275,6.054Z",
    transform: "translate(-23.558 -4.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.482,29.61,53.6,31.846l7.958,4.041,2.17,1.1Z",
    transform: "translate(-23.222 -6.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.121,27.928l-2.054-1.342L54.813,21.85,53.19,30.181l7.495-1.54Z",
    transform: "translate(-23.151 -4.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.463,10.7,55.27,19.337l5.018-1.408,4.141-1.159L59.493,13Z",
    transform: "translate(-23.509 -3.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.716,42.617l-2.426.729,9.416,4.588,4.083-8.654Z",
    transform: "translate(-22.481 -7.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.576,37.759l-2.3-1.168-7.95-4.041-1.582,4.464L49.02,41.842,55.446,39.9Z",
    transform: "translate(-22.434 -6.762)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.41,68.426l.571.762L62.147,74.7A37.083,37.083,0,0,1,63.7,66.53L58.843,68Z",
    transform: "translate(-23.876 -12.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.83,58.28l5.209,8.389,6.327-1.913Z",
    transform: "translate(-22.745 -11.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.907,69.06,51.468,73.4l-.778.754a77.985,77.985,0,0,1,9.971,1.209Z",
    transform: "translate(-22.721 -13.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.92,44.54l1.168,10.468,8.265-5.871Z",
    transform: "translate(-22.417 -8.823)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.249,95.118a19.813,19.813,0,0,0-3.089-.778l1.772,2.195c.6-.273,1.1-.538,1.474-.745.149-.091.232-.2.215-.315C57.613,95.334,57.464,95.193,57.249,95.118Z",
    transform: "translate(-23.318 -17.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.622,66.905,50.38,58.45V72.031l2.907-2.84Z",
    transform: "translate(-22.668 -11.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.232,17.093l3.66,2.178,1.192-8.67L43.7,13.8Z",
    transform: "translate(-21.52 -2.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M48.015,10.571,54.06,8.708,52.8,5.66l-1.54-3.71L43.75,11.879Z",
    transform: "translate(-21.529 -1.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.857,96.389,50.88,97.9A17.428,17.428,0,0,0,55,96.712l-1.863-2.3Z",
    transform: "translate(-22.754 -17.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.441,24.377l.513-2.617L40.658,24l-1.838.364,6.17,3.089,5.333,2.675Z",
    transform: "translate(-20.681 -4.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.346,21.065,38.51,22.8l13.1-2.592L42.4,14.73Z",
    transform: "translate(-20.628 -3.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.044,94.47c0-.008.017-.008.017-.017l.207-.315a27.635,27.635,0,0,0-3.776-.248H47.92l2.07,3.793,2.037-3.172C52.028,94.495,52.028,94.478,52.044,94.47Z",
    transform: "translate(-22.245 -17.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.309,41.907,48.628,35.4,49.6,32.64,35.8,38.4Z",
    transform: "translate(-20.162 -6.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.24,1.6A23.644,23.644,0,0,0,47.2,1.41a26.116,26.116,0,0,0-7.61,1.126l2.99,9.2Z",
    transform: "translate(-20.814 -1.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M37.336,27.346l-1.9,9.465,7.644-3.188,6.327-2.642L37.775,25.16Z",
    transform: "translate(-20.1 -5.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.481,96.925l-.571.7a14.347,14.347,0,0,0,5.06.323L46.858,94.06Z",
    transform: "translate(-21.556 -17.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.927,66.835l2.534,3.958V56.864l-8.083-3.039L35.71,52.45l6.128,9.565Z",
    transform: "translate(-20.147 -10.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.423,55.064,46.247,44.53l-8.778,5.085L35.68,50.658l2.211.828Z",
    transform: "translate(-20.142 -8.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.65,74.64a75.035,75.035,0,0,1,11.478-1.333q.509,0,.969.025L42.012,65.39l-.53-.82L39.9,66.905Z",
    transform: "translate(-19.965 -12.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.36,49.566l10.517-6.1-4.919-1.64-5.6-1.863Z",
    transform: "translate(-20.087 -8.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M42.14,94.342l1.176,2.981,2.807-3.4A32.125,32.125,0,0,0,42.14,94.342Z",
    transform: "translate(-21.252 -17.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.519,88.39a30.268,30.268,0,0,0-5.259.8l2.981,1.913Z",
    transform: "translate(-20.757 -16.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.309,94.929a.178.178,0,0,1-.116.157L40.1,96.527a14.365,14.365,0,0,0,2.468,1.019l-1.11-2.816Z",
    transform: "translate(-20.901 -17.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.636,12.311,37.663,3.16,30.21,14.53Z",
    transform: "translate(-19.201 -1.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.962,17.612l5.706,5.134.108-.224,3.76-7.793L30.2,16.925Z",
    transform: "translate(-19.2 -3.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.53,64.378l1.681-.472,6.6-1.872L34.774,52.61l-1.052,5.5Z",
    transform: "translate(-19.6 -10.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.65,64.54l-5.391,1.532-2.749.778A66.086,66.086,0,0,1,34.034,74.3Z",
    transform: "translate(-19.597 -12.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.592,90.362,38.4,89.6,36.71,92.573a29.189,29.189,0,0,1,4.588-1.11Z",
    transform: "translate(-20.319 -16.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.668,95.12a.46.46,0,0,0-.348.323.348.348,0,0,0,.19.306c.306.2.613.389.936.563l1.3-1.723A17.347,17.347,0,0,0,38.668,95.12Z",
    transform: "translate(-20.595 -17.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.248,14.39,36.337,3.575l.331-.505A32.773,32.773,0,0,0,26.88,8.627l1.5,3.644Z",
    transform: "translate(-18.629 -1.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M37.513,89.865a.214.214,0,0,1,.116-.124l.058-.091c-.53.149-1.052.315-1.557.489a1.874,1.874,0,0,0-.77,1.259,1.622,1.622,0,0,0,.629,1.234l1.524-2.675A.17.17,0,0,1,37.513,89.865Z",
    transform: "translate(-20.086 -16.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.018,25.38l-8.2,6.252L33.741,36.8Z",
    transform: "translate(-18.791 -5.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.67,24.748l8.9-.737L34.1,23.4l-4.306-3.884L27.616,17.56Z",
    transform: "translate(-17.046 -4.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.871,29.019l3.859,2.319,5.805-4.422L33.9,25.11l-7.6.621-8.712.72Z",
    transform: "translate(-17.032 -5.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.61,45.225l10.989,4.4V40l-9.217,4.389Z",
    transform: "translate(-17.723 -8.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.815,52.95,27.78,56.139A40.116,40.116,0,0,1,31.4,63.882L33.577,52.47Z",
    transform: "translate(-18.784 -10.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.426,38.486,26.489,33.31l-4,8.339L21.52,43.67l10.675-5.076Z",
    transform: "translate(-17.708 -6.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.354,51.123l-4.24-1.7L21.53,46.8c1.449,2.617,4.364,7.122,4.952,8.041l2.228-1.408Z",
    transform: "translate(-17.71 -9.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.893,10.11c-1.135.994-6.642,6.145-7.743,13.175l10.145-7.337Z",
    transform: "translate(-16.957 -2.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.372,33.37l-5.2,2.1-2.451.985a30.236,30.236,0,0,0,2.708,7.221l.762-1.607Z",
    transform: "translate(-17.055 -6.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.727,28.581,17.011,26.95a30.393,30.393,0,0,0,.489,8.016l7.685-3.105Z",
    transform: "translate(-16.917 -5.8)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 20.455,
    transform: "translate(1044.253 510.089)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1139.864 425.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3174.475,6885.193v-13.914h-61.518v-19.469",
    transform: "translate(-3092.844 -6818.115)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 39,
    height: 5,
    transform: "translate(0.188 27.911)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5,
    height: 10,
    transform: "translate(1.188 16.911)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5,
    height: 19,
    transform: "translate(11.188 7.911)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 5,
    height: 27,
    transform: "translate(21.188 -0.089)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 5,
    height: 21,
    transform: "translate(32.188 5.911)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1395.154 513.882)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3284.57,6916.715h-35.481V6889.1h-35.421",
    transform: "translate(-3213.668 -6889.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3237.932,6908H3273v30.193h-35.068",
    transform: "translate(-3237.549 -6880.38)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1060.222 481.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M606.51,428.8V396.285H853.917s55.625,1.732,55.625,52.722-55.625,49.2-55.625,49.2H636.237s-22.385.132-22.385,19.368,22.385,18.44,22.385,18.44h259.41V568.8H636.237s-54.807-1.223-54.807-51.221,54.807-51.985,54.807-51.985H853.917s25.108,1.362,25.108-18.817S853.917,428.8,853.917,428.8Z",
    transform: "translate(-581.43 -386.931)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.425 79.094)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M15.341,0H210.393V30.682l-195.052.742C6.868,31.424,0,23.814,0,15.341A15.341,15.341,0,0,1,15.341,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 28,
    height: 28,
    rx: 14,
    transform: "translate(1.405 2.125)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(3.405 4.125)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.983 10.424)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M195.052,0H0V30.682l195.052.742c8.473,0,15.341-7.61,15.341-16.083A15.341,15.341,0,0,0,195.052,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 28,
    height: 28,
    rx: 14,
    transform: "translate(180.847 0.795)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(182.847 2.795)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.815 149.225)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M195.052,0H0V30.682l195.052.742c8.473,0,15.341-7.61,15.341-16.083A15.341,15.341,0,0,0,195.052,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 28,
    height: 28,
    rx: 14,
    transform: "translate(181.015 1.994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(183.015 3.994)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M581.43,420.4h19.415V430l27.381-25.775-27.381-25.234v8.828H581.43Z",
    transform: "translate(-581.43 -378.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1162.687,678.165V645.344h17.423v-10.8l25.614,26.944-25.614,25.92v-9.247Z",
    transform: "translate(-849.315 -496.296)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.502 513.882)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3213.668,6916.715h35.481V6889.1h35.421",
    transform: "translate(-3213.668 -6889.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3273,6908h-35.068v30.193H3273",
    transform: "translate(-3202.481 -6880.38)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1257.914 503.141)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 9,
    cy: 8.5,
    rx: 9,
    ry: 8.5,
    transform: "translate(0.138 29.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 9,
    cy: 8.5,
    rx: 9,
    ry: 8.5,
    transform: "translate(165.138 29.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 9,
    cy: 8.5,
    rx: 9,
    ry: 8.5,
    transform: "translate(39.138 29.48)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 9,
    cy: 8.5,
    rx: 9,
    ry: 8.5,
    transform: "translate(204.138 29.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 64,
    height: 22,
    transform: "translate(79.138 0.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 64,
    height: 22,
    transform: "translate(79.138 27.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 64,
    height: 22,
    transform: "translate(79.138 55.48)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(1023.052 586.621)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 62,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 37,
    rx: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1.538,0H53.286V29.4H-1.538Z",
    transform: "translate(1028.203 591.178)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30,
    height: 2,
    rx: 1,
    transform: "translate(1040.052 627.621)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 16.072,
    transform: "translate(1029.642 594.831)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 21.916,
    transform: "translate(1029.642 597.753)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 21.916,
    transform: "translate(1029.642 600.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M3047.462,6969.392l5.315-8.794,12.705,2.588,5.708-9.068,22.888-7.759",
    transform: "translate(-2020.797 -6348.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M3.653,0,7.305,5.844H0Z",
    transform: "translate(1076.497 592.214) rotate(68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 66,
    height: 51,
    transform: "translate(1161.052 605.621)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 66,
    height: 12,
    transform: "translate(1161.052 605.621)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 6,
    height: 16,
    rx: 3,
    transform: "translate(1172.052 598.621)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 6,
    height: 16,
    rx: 3,
    transform: "translate(1211.052 598.621)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(1170.052 619.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1117 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1111 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1105 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1099 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1093 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1087 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1081 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1075 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1069 -560)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1117 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1111 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1105 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1099 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1093 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1087 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1081 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1075 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1069 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1117 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1111 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1105 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1099 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1093 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1087 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1081 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1075 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1069 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1117 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1111 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1105 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1099 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1093 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1087 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1081 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1075 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1069 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1117 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1111 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1105 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1099 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1093 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1087 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1081 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1075 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1069 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1117 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1111 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1105 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1099 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1093 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1087 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1081 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1075 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1069 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 4,
    height: 4,
    transform: "translate(1117 560)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1411.194 607.98)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "u",
    x2: 36.527,
    transform: "translate(12.936)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "u",
    x2: 23.377,
    transform: "translate(12.936 5.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M3316.646,6966.05l3.169,2.517,5.554-5.967",
    transform: "translate(-3316.646 -6962.454)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.611)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "u",
    x2: 36.527,
    transform: "translate(12.936)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "u",
    x2: 23.377,
    transform: "translate(12.936 5.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M3316.646,6966.05l3.169,2.517,5.554-5.967",
    transform: "translate(-3316.646 -6962.454)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.936 29.221)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "u",
    x2: 36.527
  }), /*#__PURE__*/React.createElement("line", {
    className: "u",
    x2: 23.377,
    transform: "translate(0 5.844)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.497 41.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.629,40.059a17.43,17.43,0,0,0,12.333-5.1,17.2,17.2,0,0,0,5.1-12.333,17.43,17.43,0,0,0-5.1-12.333,17.47,17.47,0,0,0-24.666,0,17.47,17.47,0,0,0,0,24.666A17.2,17.2,0,0,0,22.629,40.059Zm0-33.5A16.068,16.068,0,1,1,6.562,22.629,16.072,16.072,0,0,1,22.629,6.562Zm-1.012,16.69h.311v3H19.361v1.362h2.568v2.1h1.362v-2.1H23.6a2.879,2.879,0,1,0,0-5.758h-.311v-3H25.82V17.494H23.291V15.432H21.929v2.062h-.311a2.879,2.879,0,0,0,0,5.758Zm2.023,0a1.478,1.478,0,0,1,0,2.957H23.33v-3h.311Zm-2.023-4.357h.311v3h-.311a1.478,1.478,0,0,1-1.478-1.478A1.511,1.511,0,0,1,21.618,18.895Zm-8.481,6.614a.674.674,0,0,1-.467.856.423.423,0,0,1-.195.039.679.679,0,1,1,.661-.895Zm19.686,1.945h0a.693.693,0,0,1-.622.389.916.916,0,0,1-.311-.078.7.7,0,0,1,.622-1.245A.677.677,0,0,1,32.823,27.454Zm-18.4.739a.7.7,0,0,1-.195.973.751.751,0,0,1-.389.117.739.739,0,0,1-.584-.311A.7.7,0,0,1,13.448,28,.686.686,0,0,1,14.42,28.193Zm1.05-13.5a.693.693,0,1,1,.973.117.585.585,0,0,1-.428.156A.816.816,0,0,1,15.471,14.693Zm-2.179,1.478a.7.7,0,1,1,1.167.778.686.686,0,0,1-.584.311.751.751,0,0,1-.389-.117A.657.657,0,0,1,13.292,16.171ZM33.017,20.3a.688.688,0,1,1,.195,1.362h-.117a.708.708,0,0,1-.7-.584A.764.764,0,0,1,33.017,20.3ZM25.664,32.784a.682.682,0,0,1-.506.817H25a.7.7,0,0,1-.661-.545.676.676,0,1,1,1.323-.272Zm8.17-8.559a.679.679,0,0,1-.7.584h-.117a.688.688,0,0,1,.195-1.362A.725.725,0,0,1,33.834,24.225ZM16.56,31.305a.679.679,0,0,1-.545.272.585.585,0,0,1-.428-.156.693.693,0,1,1,.973-.117Zm5.991,1.906a.684.684,0,0,1-.7.622h-.039a.683.683,0,0,1,.117-1.362A.723.723,0,0,1,22.552,33.212Zm5.991-1.79a.692.692,0,0,1-.233.934.578.578,0,0,1-.35.078.642.642,0,0,1-.584-.35.692.692,0,0,1,.233-.934A.663.663,0,0,1,28.543,31.422ZM29.9,15.782a.688.688,0,1,1,.973.039.718.718,0,0,1-.467.195A.685.685,0,0,1,29.9,15.782ZM27.337,13.02a.681.681,0,1,1,1.167.7.642.642,0,0,1-.584.35,1.136,1.136,0,0,1-.35-.078A.749.749,0,0,1,27.337,13.02Zm4.241,5.213a.7.7,0,1,1,.934.311.733.733,0,0,1-.311.078A.667.667,0,0,1,31.578,18.233ZM11.814,19.245a.689.689,0,0,1,1.323.389.667.667,0,0,1-.661.506.351.351,0,0,1-.195-.039A.674.674,0,0,1,11.814,19.245Zm19.1,10.037a.682.682,0,0,1,.039.973.627.627,0,0,1-.506.233.718.718,0,0,1-.467-.195.688.688,0,0,1,.934-1.012ZM11.308,22.591h0a.7.7,0,0,1,1.4,0h0a.7.7,0,0,1-.7.7h0A.7.7,0,0,1,11.308,22.591ZM19.4,32.706a.681.681,0,0,1-.661.428.493.493,0,0,1-.233-.039.69.69,0,1,1,.895-.389ZM18.116,12.9a.688.688,0,0,1,.389-.895h0a.69.69,0,0,1,.506,1.284.493.493,0,0,1-.233.039A.605.605,0,0,1,18.116,12.9Zm6.186-.856a.679.679,0,1,1,1.323.311.7.7,0,0,1-.661.545h-.156A.768.768,0,0,1,24.3,12.047Zm-3.151-.039a.683.683,0,1,1,.739.622h-.039A.636.636,0,0,1,21.151,12.008Z",
    transform: "translate(-5.2 -5.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(1007.052 576.621)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 93,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 63
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1284.571 430.788)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(0.481 -0.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 93,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 63
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.861 9.785)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1200.1,428.92h24.077l6.474,7.332v37.091H1200.1Z",
    transform: "translate(-1200.1 -428.92)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 9.613)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 12.535)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 15.457)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 22.763)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 22.763)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 25.685)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 28.607)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 16.072,
    transform: "translate(3.507 31.529)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 24,
    height: 7,
    transform: "translate(3.62 35.049)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.232 9.785)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1200.1,428.92h24.077l6.474,7.332v37.091H1200.1Z",
    transform: "translate(-1200.1 -428.92)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 9.613)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 12.535)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 15.457)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 22.763)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 22.763)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 25.685)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 23.377,
    transform: "translate(3.507 28.607)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "p",
    x2: 16.072,
    transform: "translate(3.507 31.529)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpmIllustration);
export default __webpack_public_path__ + "static/media/bpm_illustration.58ebcc9e.svg";
export { ForwardRef as ReactComponent };